module.exports = __webpack_public_path__ + "img/block4.e9a6ca77.png";